var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-box"},_vm._l((_vm.infoList),function(info,idx){return _c('v-row',{key:idx},[_c('v-col',{staticClass:"text-left"},[_c('p',[_vm._v(_vm._s(info.key))])]),_c('v-col',{staticClass:"text-right"},[_c('p',[_vm._v(_vm._s(info.value))])])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }